import { useEffect, useRef, useState } from "react";
import { LOCATION, TEAM } from "services/apiEndpoints";
import { privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";
import { useDebouncedValue } from "./useDebouncedValue";
import { useAutoComplete } from "./useAutoComplete";

const selectedOptionInitialState = {
    label: "",
    value: "",
};
export const useLocationOptions = () => {
    const [status, setStatus] = useState("idle"); // 'idle' || 'loading' || 'error'
    const [options, setOptions] = useState([]);
    const [searchInputValue, setSearchInputValue] = useState("");
    const debouncedSearchValue = useDebouncedValue(searchInputValue);
    const { isOpen, onHandleOpenChange } = useAutoComplete();

    const fetchLocationOptions = async (payload) => {
        setStatus("loading");
        try {
            const queryString = makeQueryString(LOCATION, payload);
            const { data } = await privateGet(queryString);
            const responseOptions = data.data.location.map((location) => {
                return { label: location.name, value: location._id };
            });
            setOptions(responseOptions);
            setStatus("idle");
        } catch (error) {
            setStatus("error");
        }
    };

    const onSearchInputValueChange = (event, newInputValue) => {
        // here only string get
        setSearchInputValue(newInputValue);
    };

    const onSelectedOptionChange = (event, newValue) => {
        // in this format: {label: '', value: ''}
        // selectedOptionRef.current = newValue;
        setSearchInputValue("");
    };

    const onHandleOpenOptionsListOpenChange = (value) => {

        onHandleOpenChange(value);
    };

    useEffect(() => {
        fetchLocationOptions({
            pageNumber: 1,
            limit: 10,
            search: debouncedSearchValue,
        });
    }, [debouncedSearchValue]);

    return {
        isOpen,
        options,
        // selectedOption: selectedTeam,
        searchInputValue,
        isError: status === "error",
        isLoading: status === "loading",
        onSelectedOptionChange,
        onSearchInputValueChange,
        onHandleOpenChange: onHandleOpenOptionsListOpenChange,
    };
};
